<style>

</style>

<template>

    <!-- Content -->
    <div class="admin-content">
        

        <div class="row">
           <div class="col-sm-12 col-md-4"></div>
            <div class="col-md-4 col-sm-12 mt-5">
      <div class="card profile-card text-center p-3">

        <!-- Avatar -->
        <div class="avatar-wrapper">
          <img id="avatarPreview" :src="this.$store.state.img_url+user.avator" class="profile-avatar">
        </div>

        <h5 class="mt-2">{{user.username}}</h5>
        <p class="text-muted mb-1">{{user.phone}}</p>
        <p class="text-primary text-sm">{{user.role_name}}</p>

        <!-- Update Avatar -->
        <!--form class="mt-3">
          <label class="form-label small fw-semibold">Update Avatar / Location</label>
          <input type="file" class="form-control form-control-sm">

          <div class="mb-3 mt-3">
            <input type="text" class="form-control" placeholder="Location">
          </div>
          <button class="btn btn-outline-primary w-100">
            Update Profile
          </button>
        </form-->

        <hr>
      <div v-if="searching" class="mt-1">
            <div class="text-center">
                <div class="spinner-grow text-success" role="status"></div>
                <div class="spinner-grow text-danger" role="status"></div>
                <div class="spinner-grow text-warning" role="status"></div>
            </div>
        </div>

        <!-- Update Info -->
        <form>
          <label class="form-label small fw-semibold">Update Password</label>
          <div class="mb-2">
            <input type="password" v-model="form.cpassword" class="form-control" placeholder="Current Password">
          </div>

          <div class="mb-3">
            <input type="password" v-model="form.npassword" class="form-control" placeholder="New Password">
          </div>
   
            <button type="button" @click="updatePassword()" class="btn-primary font-bold mt-3">
                  <i class="fas fa-check me-2"></i>
                  Update Password
                </button>
        </form>

      </div>
    </div>
     <div class="col-sm-12 col-md-4"></div>
        </div>
   
    </div>
</template>
<script>
import axios from "axios";
import UserAvatar from "@/components/UserAvatar.vue";
import OrderStatus from "@/components/OrderStatus.vue";
import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";

export default {
    components: {
        UserAvatar,
        OrderStatus,
        PriceFormat,
        PhoneFormat,
        DateFormat
    },
    data() {
        return {
            searching: false,
            form:{
                npassword:"",
                cpassword:"",
               
            },
            user: this.$attrs.user
        };
    },
    methods: {
         async updatePassword(){
    
           var form = this.form

           if(this.form.npassword.length < 8){
            alert("Give atleast 8 characters for new password")
            return
           }

            const confirmAssign = window.confirm(
        `Are you sure you want to change password?`
      );

      if (!confirmAssign) {
        //window.location.reload()
        return
      }else{

var response = await axios.post(this.$store.state.api_url + "/update-password", form)
    .catch((errors) => {

        var message = "Network or Request Errors";
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {

        this.form.npassword = ""
        this.form.cpassword = ""

      var message = response.data.message
          this.$toast.success(message, { duration:5000, dismissible: true });

      } else {
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        
      }
    }
        },
        async staffDatas() {
            this.searching = true
            var response = await axios
                .get(this.$store.state.api_url + "/staff-datas")
                .catch((errors) => {
                    this.searching = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            console.log(response.data)
            if (response.data.success) {
                this.searching = false
                var staffs = response.data.staffs

                this.staffs = staffs;

                var admins = staffs.filter(function (obj) {
                    return obj.role == 1;
                });

                var operators = staffs.filter(function (obj) {
                    return obj.role == 2;
                });

                var sales = staffs.filter(function (obj) {
                    return obj.role == 3;
                });

                this.sales = sales
                this.operators = operators
                this.admins = admins

            } else {

                this.searching = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        }

    },
    created() {
        this.$store.state.page_name = "My Profile"
        //this.staffDatas()

    },
};
</script>
